// src/pages/Verify/VerifyEmail.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./VerifyEmail.css";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

const VerifyEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifying your email...");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    // DEBUG LOGS - Added as requested
    console.log("🔍 API_URL:", API_URL);
    console.log("🔍 Full verify URL:", `${API_URL}/auth/verify?token=${token}`);
    console.log("🔍 URL:", window.location.href);
    console.log("🔍 Token from URL:", token);

    if (!token) {
      setError("Invalid verification link - no token found");
      setMessage("");
      setLoading(false);
      return;
    }

    const verifyEmail = async () => {
      try {
        console.log("📤 Making verification request...");
        
        // Use query parameter format to match deployed backend
        const response = await fetch(`${API_URL}/auth/verify?token=${encodeURIComponent(token)}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        console.log("📥 Response status:", response.status);
        
        const data = await response.json();
        console.log("📥 Response data:", data);

        if (response.ok && data.status === "success") {
          setMessage("✅ Email verified successfully! Redirecting to login...");
          setError("");
          setTimeout(() => {
            navigate("/login");
          }, 3000);
        } else {
          throw new Error(data.detail || data.message || "Verification failed");
        }
      } catch (err) {
        console.error("❌ Verification error:", err);
        setError(err.message || "Something went wrong during verification");
        setMessage("");
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [location.search, navigate]);

  const handleResendEmail = async () => {
    const email = prompt("Enter your email to resend verification:");
    if (email) {
      try {
        // FIXED: Send email as query parameter instead of body
        const response = await fetch(
          `${API_URL}/auth/resend-verification?email=${encodeURIComponent(email)}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            // No body needed - email is in query parameter
          }
        );
        
        const data = await response.json();
        if (response.ok) {
          setMessage(data.message || "Verification email resent! Check your inbox.");
          setError("");
        } else {
          setError(data.detail || "Failed to resend email");
        }
      } catch (err) {
        console.error("Resend error:", err);
        setError("Failed to resend verification email");
      }
    }
  };

  return (
    <div className="verify-container">
      <div className="verify-content">
        <h2>Email Verification</h2>
        
        {loading && (
          <div className="loading">
            <div className="spinner"></div>
            <p>Verifying your email...</p>
          </div>
        )}
        
        {error && (
          <div className="error-message">
            <p className="error">❌ {error}</p>
            <button onClick={handleResendEmail} className="resend-btn">
              Resend Verification Email
            </button>
            <button onClick={() => navigate("/login")} className="login-btn">
              Go to Login
            </button>
          </div>
        )}
        
        {message && !error && (
          <div className="success-message">
            <p className="success">{message}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;